<template>
  <div>
    <page-header :header="`${type} Page`">
      <router-link
        v-if="id && currentPage && currentPage.published"
        :to="`/partner/${currentPage.slug}`"
        class="inline-block no-underline bg-white text-black rounded-lg p-4 uppercase text-sm font-medium align-bottom"
      >
        <i class="far fa-eye fa-fw fa-lg mr-1"></i>
        Preview
      </router-link>
      <button v-if="id" @click="showDeleteModal = true" class="bg-white rounded-lg p-4 uppercase text-sm font-medium align-bottom ml-4">
        <i class="far fa-trash-alt fa-fw fa-lg mr-1" />
        Delete Page
      </button>
      <deletion-modal
        v-if="showDeleteModal"
        @confirmed="deletePage"
        @leave="showDeleteModal = false"
        @dismissed="showDeleteModal = false"
      >
        <p class="text-center">Are you sure you wish to delete the page? This cannot be undone.</p>
      </deletion-modal>
    </page-header>

    <div class="mb-6 -mt-2 pb-4 border-b-4">
      <div class="flex flex-wrap items-center -mx-4">
        <div class="px-4 w-full lg:w-2/3">
          <p class="mb-1">Page title and intro text:</p>
          <input v-model="currentPage.title" type="text" name="title" id="title" placeholder="Title" class="input w-full mb-3 bg-white" :class="{ 'border-red-dark': this.errorBag.get('title') }">
          <input v-model="currentPage.intro" type="text" name="subtitle" id="subtitle" placeholder="Subtitle" class="input w-full mb-3 bg-white">
        </div>
        <div class="px-4 w-full lg:w-1/3">
          <div class="flex-col items-center mb-3">
            <div class="text-left w-full py-5 mb-3">
              <input id="published" class="leading-tight" type="checkbox" v-model="currentPage.published">
              <label for="published">
                <span class="text-sm">
                  Publish
                </span>
              </label>
            </div>
          <div class="flex flex-col items-center">
            <button @click="savePage" :disabled="isSaving" class="bg-tertiary text-white rounded px-4 py-3 uppercase text-sm font-medium align-bottom ml-auto w-full">
              <i v-if="isSaving" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
              <div v-else>
                <i class="far fa-save fa-fw fa-lg" />
                Save Page
              </div>
            </button>
          </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap items-center pt-2" v-if="system.networks && system.networks.length > 1">
        <p class="w-full mb-2">Choose Network:</p>
        <div class="xl:flex-row md:flex md:flex-row sm:flex-col space-between">
          <div v-for="(network, i) in system.networks" :key="i" class="text-sm uppercase">
            <input  type="radio"  :id="+i" name="network.id" :value="network.id" v-model="currentPage.assigned_network">
            <label  :for="+i" class="ml-4 mt-2">{{ network.name }}</label>
          </div>
          <input  type="radio" id="all" name="network.id"  :value="null" v-model="currentPage.assigned_network">
          <label  for="all"  class="ml-4 mt-2">ALL</label>
        </div>
      </div>
    </div>

    <div class="mb-6 -mt-2 pb-4 border-b-4">
      <div class="flex -mx-4">
        <div class="px-4 w-full">
          <h3 class="mb-5">Partner Options</h3>

          <div class="flex items-center mb-4">
            <div class="w-full">
              <label class="mb-2 block" for="">Header Image</label>
              <div class="flex">
                <input v-model="currentPage.partner_options.image" class="input w-full bg-white" type="text" name="something" placeholder="Specify a URL to an image or use the media manager" />
                <button title="Open Media Manager" @click="openMediaManager($event)" class="border px-6 border-l-0 bg-white">
                  <i class="fa fa-file"></i>
                </button>
              </div>
            </div>
          </div>

          <div>
            <label class="mb-2 block" for="partner_intro">Partner Intro</label>
            <textarea
              rows="5"
              id="partner_intro"
              class="w-full input bg-white"
              v-model="currentPage.partner_options.intro"
              placeholder="An intro about the partner that will be shown on the partners page"
            ></textarea>
          </div>

        </div>
      </div>
    </div>

    <div class="mb-6 -mx-4 flex flex-wrap">
      <div class="w-full lg:w-2/3 px-4">
        <div class="bg-white rounded-lg p-6 pt-0 mt-12">
          <div class="flex flex-wrap items-center border-b mb-6 pb-2">
            <page-icon-picker
              :icon="currentPage.icon"
              :color="currentPage.icon_color"
              @change="iconSelected"
            />
            <input type="text" placeholder="Title" class="input w-2/3 mx-0 mr-4 sm:mx-6" v-model="blockTitle">
            <div class="rounded-full h-10 w-10 flex justify-center items-center border cursor-pointer" @click="informativeMediaIsShowing = true">
              <i class="fas fa-link fa-lg" />
            </div>
            <modal
              v-if="informativeMediaIsShowing"
              @leave="informativeMediaIsShowing = false"
              width="40vw"
              :scrollY="false"
              :showCloseBtn="true"
            >
              <div class="flex items-center pb-4 border-b">
                <div class="w-16 h-16 flex justify-center items-center rounded-full border">
                  <i class="fas fa-link fa-2x" />
                </div>
                <span class="ml-4 text-2xl font-medium">Informative Media</span>
              </div>
              <div class="flex items-center py-6 border-b">
                <div class="w-1/4 mr-4 flex items-center">
                  <i class="fas fa-play fa-lg mx-4 text-tertiary" />
                  <span>Video Content</span>
                </div>
                <input type="url" class="input flex-grow" placeholder="https://" v-model="currentPage.video_url">
              </div>
              <div class="flex items-center py-6 border-b">
                <div class="w-1/4 mr-4 flex items-center">
                  <i class="fas fa-book-open fa-lg mx-4 text-tertiary" />
                  <span>Page Turner</span>
                </div>
                <input type="url" class="input flex-grow" placeholder="https://" v-model="currentPage.page_turner_url">
              </div>
              <div class="flex items-center py-6">
                <div class="w-1/4 mr-4 flex items-center">
                  <i class="fas fa-laptop fa-lg mx-4 text-tertiary" />
                  <span>Website</span>
                </div>
                <input type="url" class="input flex-grow" placeholder="https://" v-model="currentPage.website_url">
              </div>
            </modal>
          </div>

          <div>
            <div v-for="(block, index) in blocks" :key="index"
              class="relative" :class="{ 'mb-6 pb-4 border-b': index < blocks.length - 1 }">
              <button v-if="index > 0" type="button" @click="removeBlock(index)" class="absolute pin-t pin-r bg-white -mt-2 -mr-2 rounded-full border h-6 w-6 flex justify-center items-center z-10">
                <i class="fas fa-times fa-xs" />
              </button>
              <tinymce
                :init="editorConfig"
                v-model="block.settings.content"
                @onChange="onTinyMceContentChange"
              />
            </div>
            <div class="mt-4 pt-6 flex justify-center border-t">
              <button type="button" @click="addBlock" class="w-48 px-4 py-1 flex items-center justify-center text-grey-darkest rounded-lg shadow hover:shadow-none border border-blue bg-white">
                <span class="text-2xl mr-2">&#43;</span>
                Add Text Block
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full lg:w-1/3 px-4 mt-12">
        <div v-for="(module, index) in modules" :key="index" class="relative">
          <button type="button" @click="removeModule(index)" class="absolute pin-t pin-r bg-white -mt-2 -mr-2 rounded-full border h-6 w-6 flex justify-center items-center">
            <i class="fas fa-times fa-sm" />
          </button>
          <component :is="module.type" :module="module" class="mb-6"></component>
        </div>
        <module-picker v-if="isPickingModule" @click="addModule"></module-picker>
        <div class="flex justify-center">
          <button type="button" @click="isPickingModule = true" :disabled="isPickingModule"
            :class="{ 'cursor-not-allowed opacity-50': isPickingModule }"
            class="w-48 px-4 py-1 flex items-center justify-center text-grey-darkest rounded-lg shadow hover:shadow-none border border-blue bg-white">
            <span class="text-2xl mr-2">&#43;</span>
            Add Module
          </button>
        </div>
      </div>
    </div>

    <modal
      height="90vh"
      width="70vw"
      v-if="mediaManagerVisible"
    >
      <media-manager
        @selected="selectMedia($event)"
        @closeMediaManager="mediaManagerVisible = false"
      />
    </modal>
  </div>
</template>

<script>
import ModulePicker from '@/components/cms/ModulePicker'
import CallToAction from '@/components/cms/CallToAction'
import SimpleCta from '@/components/cms/Link'
import Media from '@/components/cms/Media'
import DeletionModal from '@/components/Modals/DeletionModal'
import { head, find } from 'lodash'
import { mapState, mapMutations, mapActions } from 'vuex'
import api from '@/http'
import ErrorBag from '@/ErrorBag'
import PageIconPicker from '@/components/cms/PageIconPicker'
import mceConfig from '@/mixins/TinyMCE'

export default {
  mixins: [ mceConfig ],
  components: { ModulePicker, CallToAction, Media, SimpleCta, PageIconPicker, DeletionModal },
  props: ['id'],
  created () {
    this.loadPage()
  },
  watch: {
    pages () {
      this.loadPage()
    }
  },
  data () {
    return {
      showDeleteModal: false,
      isSaving: false,
      isPickingModule: false,
      isManagingMenus: false,
      informativeMediaIsShowing: false,
      errorBag: new ErrorBag(),
      mediaManagerVisible: false,
      currentPage: {
        assigned_network: null,
        slug: null,
        title: null,
        intro: null,
        type: 'partner',
        published: false,
        icon: null,
        partner_options: {
          image: '',
          intro: '',
          platinum: 0
        },
        video_url: null,
        page_turner_url: null,
        website_url: null,
        content: [
          {
            type: 'text',
            title: '',
            settings: { content: '' }
          }
        ],
        modules: [],
        product_module: null,
        product_config: []
      }
    }
  },
  computed: {
    ...mapState([
      'pages', 'menus', 'system'
    ]),
    type () {
      return this.id ? 'Edit Partner' : 'Create New Partner'
    },
    blocks () {
      return this.currentPage.content
    },
    modules () {
      return this.currentPage.modules
    },
    blockTitle: {
      get () {
        if (this.blocks.length === 0) {
          this.addBlock()
        }

        return head(this.blocks).title
      },
      set (newValue) {
        head(this.blocks).title = newValue
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPage'
    ]),
    ...mapActions([
      'displayToastNotification'
    ]),
    head: head,
    iconSelected (data) {
      this.currentPage.icon = data.icon
      this.currentPage.icon_color = data.color
    },
    loadPage () {
      if (this.id && this.pages && this.pages.length > 0) {
        this.currentPage = find(this.pages, p => p.slug === this.id)
      }
    },
    handleSaveError (error) {
      this.errorBag.store(error.response.data)
      this.isSaving = false
      this.displayToastNotification({
        type: 'warning',
        icon: 'fa-bell',
        title: 'Unable to save page',
        info: error.response.data.message
      })
    },
    handleSaveSuccess (response) {
      this.setPage(response.data)
      this.isSaving = false
      this.displayToastNotification({
        type: 'success',
        icon: 'fa-check',
        title: 'Page Saved',
        info: `Page "${this.currentPage.title}" has been successfully saved.`
      })
    },
    saveAndPreview () {
      this.savePage()
      this.$router.push(`/${this.currentPage.slug}`)
    },
    savePage () {
      this.isSaving = true
      this.errorBag.clear()
      if (this.id) {
        api.patch(`pages/${this.id}`, this.currentPage)
          .then(response => {
            this.handleSaveSuccess(response)
          })
          .catch(error => {
            this.handleSaveError(error)
          })
      } else {
        api.post(`pages`, this.currentPage)
          .then(response => {
            this.handleSaveSuccess(response)
            this.$router.back()
          })
          .catch(error => {
            this.handleSaveError(error)
          })
      }
    },
    deletePage () {
      this.showDeleteModal = false
      api.delete(`pages/${this.id}`)
        .then(response => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Page Deleted',
            info: `Partner page "${this.currentPage.title}" has been successfully deleted.`
          })
          this.$router.back()
        })
        .catch(error => {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation',
            title: 'Unable to delete page',
            info: error.response.data.message
          })
        })
    },
    addBlock () {
      this.blocks.push({
        type: 'text',
        title: null,
        settings: { content: '' }
      })
    },
    removeBlock (index) {
      this.blocks.splice(index, 1)
    },
    blockContent (block) {
      if (!block.settings) {
        block.settings = { content: '' }
      }
      return block.settings.content
    },
    addModule (module) {
      this.modules.push(module)
      this.isPickingModule = false
    },
    removeModule (index) {
      this.modules.splice(index, 1)
    },
    onContentUpdate (module, html) {
      module.content = html
    },
    onTinyMceContentChange (event, editor) {
      let content = editor.getContent()
      let emptyListItem = '<li>&nbsp;</li>'
      if (content.includes('mce-toc') && content.includes(emptyListItem)) {
        content = content.replace(new RegExp(emptyListItem, 'g'), '')
        if (typeof content === 'string' && content.length !== 0) {
          editor.setContent(content)
        }
      }
    },
    openMediaManager (e) {
      this.mediaManagerVisible = true
    },
    selectMedia (file) {
      this.currentPage.partner_options.image = file.path
      this.mediaManagerVisible = false
    }
  }
}
</script>
